import { CmsGradFairGradProgramLinksBlockLoadable } from './CmsGradFairGradProgramLinksBlockLoadable';

import type { CmsApiGradFairGradProgramLinksBlockData } from '#/modules/cms/api/types/blocks/CmsApiGradFairGradProgramLinksBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsGradFairGradProgramLinksBlockMapping: CmsBlockMapping<CmsApiGradFairGradProgramLinksBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsGradFairGradProgramLinksBlockLoadable,
  };
